/**
 * Global mount for the chrome's "tap balance → quick dashboard"
 * full-page screen (variant D, founder revision 2026-05-24 PM —
 * switched from bottom sheet to full-page after comparing all four
 * variants on /dashboard/preview).
 *
 * Listens for `granbay.quickdashboard.open` and shows the full-screen
 * overlay (identity + balance + 4 quick actions + 5 latest activities)
 * that pairs with the deeper /dashboard route via the "View full
 * dashboard →" CTA inside the panel.
 *
 * Bottom-nav Balance cell fires the event on mobile. Desktop header
 * user-pill keeps its existing /home Link (unchanged, per founder
 * direction not to touch desktop chrome).
 */
"use client";

import { useCallback, useEffect, useState } from "react";
import { QuickDashboardFullScreen } from "@/components/v6/dashboard/QuickDashboardFullScreen";

export function V6GlobalQuickDashboard() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("granbay.quickdashboard.open", handler);
    return () =>
      window.removeEventListener("granbay.quickdashboard.open", handler);
  }, []);

  const close = useCallback(() => setOpen(false), []);

  return <QuickDashboardFullScreen open={open} onClose={close} />;
}
